const hostname =
  typeof window !== "undefined" ? window.location.hostname : "localhost";

type EndpointConfig = { api: string; ws: string };

const DEFAULT_ENDPOINTS: EndpointConfig = {
  api: "https://api.dev.creatorcatalyst.ai/",
  ws: "wss://api.dev.creatorcatalyst.ai/",
};

// Map known hostnames to the API/WebSocket endpoints they should use.
const endpointByHost: Record<string, EndpointConfig> = {
  "webccdev.blitzfc.com": {
    // api: 'https://ccdev.blitzfc.com/',
    // ws: 'wss://ccdev.blitzfc.com/'
    api: "https://api.dev.creatorcatalyst.ai/",
    ws: "wss://api.dev.creatorcatalyst.ai/",
  },
  "cc.blitzfc.com": {
    // api: "https://ccapi.blitzfc.com/",
    // ws: "wss://ccapi.blitzfc.com/",
    api: "https://api.dev.creatorcatalyst.ai/",
    ws: "wss://api.dev.creatorcatalyst.ai/",
  },
};

function readLocalOverride(): EndpointConfig | null {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const raw = window.localStorage?.getItem("cc.endpointOverride");
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (parsed?.api && parsed?.ws) {
      return parsed as EndpointConfig;
    }
  } catch (error) {
    // Ignore malformed values so a bad override does not break boot.
    console.warn("[env] invalid endpoint override ignored", error);
  }
  return null;
}

const overrideEndpoints = readLocalOverride();

const selectedEndpoints =
  overrideEndpoints ??
  endpointByHost[hostname] ??
  (hostname.endsWith("ccdev.blitzfc.com")
    ? endpointByHost["webccdev.blitzfc.com"]
    : hostname.endsWith("cc.blitzfc.com")
    ? endpointByHost["cc.blitzfc.com"]
    : DEFAULT_ENDPOINTS);

export const environment = {
  production: false,
  useLocalAuth: false,
  showOutreachMenu: true, // Only show in development
  showOutreachIcon: true, // Only show in development
  showSettingsMenu: true, // Only show in development
  enableMailStats: false, // Only call mail stats in development
  // Social Monitoring module
  showSocialMonitoringMenu: true,
  // Safety module feature flags
  showSafetyMenu: false, // Legacy Safety hidden in dev — replaced by the Risk module (prod/stage still pending QA)
  showSafetyCriteria: true, // Show "Manage Criteria" button and criteria selection
  showSafetyCriteriaAddButton: true, // Show [+] button to create new criteria inline
  showCreatorSoftDelete: true, // Show bulk soft-delete (Delete) button on creator-cards
  // Pendo Analytics feature flags
  pendoEnabled: true, // Enable Pendo analytics integration
  pendoUseGtm: false, // If true, assumes Pendo is loaded via Google Tag Manager
  // Credits SSE reconnect state machine (SSE hardening contract, §4.7).
  // Set to false to fall back to connect-once with no reconnect on a clean close.
  creditsSseHardenedReconnect: true,
  // Credits SSE shared across tabs (CAT-1227): one stream per browser profile,
  // elected with Web Locks and relayed over BroadcastChannel. Opt-in; takes
  // effect on the next page load. Falls back to one stream per tab when off or
  // when either API is unavailable.
  creditsSseSharedStream: false,
  apiUrl: selectedEndpoints.api,
  websocketUrl: selectedEndpoints.ws,
  recaptchaSiteKey: "6LdeXhEsAAAAAKZ2fGcUvVmGZ1QB7GBWzXpMgh30",
  cognito: {
    region: "us-west-1",
    userPoolId: "us-west-1_IfszX3GRj",
    userPoolWebClientId: "4lmgc4pk73p8vce27h09q3adm2",
    mandatorySignIn: false,
    oauth: {
      domain: "signup-dev.creatorcatalyst.ai",
      scope: ["email", "openid", "profile"],
      redirectSignIn: "https://dev.creatorcatalyst.ai/auth/callback",
      redirectSignOut: "https://dev.creatorcatalyst.ai/logout",
      responseType: "code",
    },
  },
};
